const aadb2cAuthorityDomain = 'contentexpressio.b2clogin.com'
const aadb2cUserFlow = 'B2C_1_SUSI'

const envVars = {
  staging: {
    bookingWorkflowId: '1bcd672a-71f1-477b-9278-4ecef68e876b',
    cms1Url: 'https://staging-cms.contenthouse.io',
    workbaseUrl: 'https://func-ch-staging-backend-workbase.azurewebsites.net/api',
    supportEmail: [
      {
        email: 'developers@contenthouse.io',
        name: 'Developers - Content House Inc.'
      },
      {
        email: 'product.qa@contenthouse.io',
        name: 'QA - Content House Inc.'
      },
      {
        email: 'pearls@contenthouse.io',
        name: 'Pearl - Content House Inc.'
      }
    ]
  },
  production: {
    bookingWorkflowId: '22543208-09fb-42d8-abb3-c11321432df4',
    cms1Url: 'https://cms.contenthouse.io',
    workbaseUrl: 'https://func-ch-backend-workbase.azurewebsites.net/api',
    supportEmail: [{
      email: 'support@contenthouse.io',
      name: 'Content House Inc.',
    }]
  },
}

const env = process.env.REACT_APP_APPLICATION_ENV || 'staging'

const {
  bookingWorkflowId,
  cms1Url,
  workbaseUrl,
  supportEmail,
} = envVars[env]

const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // like '/cms2-contenthouse/react/default'
  aadb2cApiScopes: 'https://contentexpressio.onmicrosoft.com/c576e67d-e31f-4fbd-a417-e6f181b94dac/internal_access',
  aadb2cAuthorityDomain,
  aadb2cClientId: '4bc799a3-8939-44fa-bb79-48c37b17a4bc',
  aadb2cUserFlow,
  aadb2cUserFlowAuthority: `https://${aadb2cAuthorityDomain}/tfp/contentexpressio.onmicrosoft.com/${aadb2cUserFlow}`,
  apimKey: 'd1c17ce8091944429f557ae46c3031e8',
  basename: '/',
  bookingWorkflowId,
  borderRadius: 12,
  cms1Url,
  defaultPath: '/',
  env,
  fontFamily: `'Roboto', sans-serif`,
  workbaseUrl,
  appDeepLinkScheme: 'https://stcedeeplink.z8.web.core.windows.net',
  appStoreUrl: 'https://apps.apple.com/ph/app/content-express/id6745817823',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=io.contenthouse.contentexpress',
  supportEmail,
}

export default config
